.infobox {
  background: var(--dds-card-bg-accent);
  padding: var(--dds-spacing-medium-32);
  padding-top: var(--dds-spacing-small-8);
  border-radius: var(--dds-radius-medium);
}

.infobox ul {
  padding-left: var(--dds-spacing-small-16);
  margin-bottom: 0;
}

.infobox a {
  margin-top: var(--dds-spacing-medium-24);
  margin-bottom: 0;
}

.illustration {
  margin-top: var(--dds-spacing-large-48);
  width: 50%;
  margin-right: auto;
  margin-left: auto;
  display: block;
}
